import { render } from "./SearchHospital.vue?vue&type=template&id=2109b5c1&scoped=true&bindings={\"state\":\"setup\",\"area\":\"setup\",\"parentClass\":\"setup\",\"firstButtonsClass\":\"setup\",\"jumpThird\":\"setup\",\"jumpSecond\":\"setup\",\"jumpFirst\":\"setup\"}"
import script from "./SearchHospital.vue?vue&type=script&lang=ts"
export * from "./SearchHospital.vue?vue&type=script&lang=ts"

import "./SearchHospital.vue?vue&type=style&index=0&id=2109b5c1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2109b5c1"

export default script